import React from "react"
import * as styles from "./index.module.css"
import { StaticImage } from "gatsby-plugin-image"
import Heading from "../text/heading/heading"
import BodyText from "../text/body-text/body-text"

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const HeaderBanner = () => {
  const skillStatistics = [
    {
      image: (
        <StaticImage
          src="../../images/index/homeSkilledBanner/Group 79187.png"
          alt="An animated image of light bulb indicating the logical thinking"

          {...commonImageProps}
          className={styles.logoImage}
        />
      ),
      title: "1.1 Million+",
      description: "Skilled",
      bgColor: '#E6E2FE',
      borderColor: '#4559ED'
    },
    {
      image: (
        <StaticImage
          src="../../images/index/homeSkilledBanner/Group 79186.png"
          alt="An animated image of user doing the freelancing work"

          {...commonImageProps}
          className={styles.logoImage}
        />
      ),
      title: "1.6 Million+",
      description: "Up-Skilled",
      bgColor: '#D1FFDE',
      borderColor: '#10BF5F'
    },
    {
      image: (
        <StaticImage
          src="../../images/index/homeSkilledBanner/Group 77593.png"
          alt="An animated image of an employee as arecruting employee"

          {...commonImageProps}
          className={styles.logoImage}
        />
      ),
      title: "80%",
      description: "Placed",
      bgColor: '#FFE7CB',
      borderColor: '#F8941F'
    },
  ]

  return (
    <section className={`mx-auto  container`}>
      <div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4  py-4 ${styles.banner}`}
      >
        {skillStatistics.map((skill, index) => (
          <article
            key={index}
            className={`flex items-center justify-start  p-2 gap-2 ${styles.skillCard}`}
            style={{
              border: `1px solid ${skill.borderColor}`,
              backgroundColor: skill.bgColor
            }}
          >
            <div className={` ${styles.bannerImage}`}>{skill.image}</div>
            <div
              className={` h-full text-center md:text-left ${styles.skillCardText} `}
            >
              <Heading variant="h5">{skill.title}</Heading>
              <BodyText variant="bodyText7">{skill.description}</BodyText>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default HeaderBanner
